import { render, staticRenderFns } from "./SysRoleManNew.vue?vue&type=template&id=2e814180&scoped=true"
import script from "./SysRoleManNew.vue?vue&type=script&lang=js"
export * from "./SysRoleManNew.vue?vue&type=script&lang=js"
import style0 from "./SysRoleManNew.vue?vue&type=style&index=0&id=2e814180&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e814180",
  null
  
)

export default component.exports